import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import LocaleSelector from '../../LocaleSelector/LocaleSelector';
import MenuItem from './MenuItem';
import logo from '../../../assets/images/sp-logo-black.svg';
import logoWhite from '../../../assets/images/sp-logo.svg';
import { NAVIGATION_DESKTOP_HEIGHT, PAGE_WIDTH } from '../../../styles/variables.style';

const StyledHeader = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
`;

const HeaderInner = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  max-width: 100%;
  padding: 0 20px;
  width: ${PAGE_WIDTH}px;
  height: ${NAVIGATION_DESKTOP_HEIGHT}px;
`;

const Logo = styled.img`
  position: absolute;
  top: 0;
  left: 0;
`;

const LogoBlack = Logo.extend`
  opacity: ${({ white }) => (white ? '0' : '1')};
  transition: opacity 0.3s;
`;

const LogoWhite = Logo.extend`
  opacity: ${({ white }) => (white ? '1' : '0')};
  transition: opacity 0.3s;
`;

const DesktopHeader = ({ menu, locale, show, top, onlyLogo, white }) => (
  <StyledHeader>
    <HeaderInner>
      <a
        href={`https://www.shiseido-professional.com/${locale}`}
        style={{ position: 'relative', width: '170px', height: '54px' }}
      >
        <LogoBlack src={logo} white={top && white} />
        <LogoWhite src={logoWhite} white={top && white} />
      </a>

      {!onlyLogo && (
        <React.Fragment>
          {/* ニュース&イベント、クリエーション、美容診断などのメニュー表示 */}
          {menu.map(menuItem => (
            <MenuItem
              key={menuItem.label || menuItem.key}
              menuItem={menuItem}
              top={top}
              locale={locale}
              white={white}
            />
          ))}
          <LocaleSelector position="bottom-left" show={show} />
        </React.Fragment>
      )}
    </HeaderInner>
  </StyledHeader>
);

DesktopHeader.defaultProps = {
  menu: [{ key: 0 }, { key: 1 }, { key: 2 }, { key: 3 }, { key: 4 }, { key: 5, children: [] }],
  onlyLogo: false,
};

DesktopHeader.propTypes = {
  locale: PropTypes.string.isRequired,
  menu: PropTypes.arrayOf(PropTypes.shape()),
  show: PropTypes.bool.isRequired,
  top: PropTypes.bool.isRequired,
  onlyLogo: PropTypes.bool,
  white: PropTypes.bool.isRequired,
};

const mapState = state => ({
  menu: state.siteOptions.menu,
  locale: state.locale,
});

export default connect(mapState)(DesktopHeader);



// WEBPACK FOOTER //
// ./src/components/GlobalMenu/Desktop/DesktopHeader.js